import Bulletin from './img/icons/bulletin_logo.svg';
import Dashboard from './img/icons/dashboard_logo.svg';
import Hamta from './img/icons/hamta_logo.svg';
import Iwa from './img/icons/iwa_logo.svg';
import Map from './img/icons/map_logo.svg';
//import Orders from './img/icons/orders_logo.svg';
import Redirect from './img/icons/route_redirection_logo.svg';
//import SenseView from './img/icons/senseview_logo.svg';
//import Settings from './img/icons/settings_logo.svg';
import Some from './img/icons/some_logo.svg';
//import Sso from './img/icons/sso_logo.svg';
//import Validation from './img/icons/validation_logo.svg';

export default function getIcon(icon: string) {
  switch (icon.toLowerCase()) {
    case 'hamta':
      return Hamta;
    case 'iwa':
      return Iwa;
    case 'map':
      return Map;
    case 'redirect':
      return Redirect;
    case 'some':
      return Some;
    case 'bulletin':
      return Bulletin;
    default:
      return Dashboard;
  }
}

/*
icon: 'bulletin'
        icon: 'dashboard'
        icon: 'hamta',
        icon: 'iwa'
        icon: 'map'
        icon: 'orders',
        icon: 'redirect'
        icon: 'senseview',
        icon: 'settings',
        icon: 'some'
        icon: 'some',
        icon: "sso"
        icon: 'validation'
*/



// WEBPACK FOOTER //
// ./src/service_icons.ts